// @ts-chceck
import styled from 'styled-components';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import Icon from 'components/base/Icon';
import { SPACES, LINE_HEIGHT } from 'common/constants/sizes';
import svgLogo from 'images/logos/linearb-logo.svg';
import SlackConnectedSuccessfullyBackground from 'images/characters/character-slack-connected-successfully.svg';
import PurpleDude from 'images/characters/purple-dude.svg';
import SpeechBalloon from 'images/characters/speech-balloon.svg';
import AppRouter from 'common/AppRouter';
import { useHistory } from 'react-router';
import * as ZendeskService from 'common/services/zendesk.service';
import {
  getButtonProps,
  getCollaborationProviderName
} from './link-account-modal.service';
import { usePostAskForInvitation } from './usePostAskForInvitation';
import { getColor } from 'common/constants/_colors';
import { LBButton } from '@linearb/buzz';

const Logo = styled.img`
  width: 10rem;
  padding-top: ${SPACES['big']};
`;

const SpeechBalloonBox = styled(Flex)`
  justify-content: center;
  align-items: center;
  border: 0px solid red;
  width: 14rem;
  height: 6rem;
  background: url(${SpeechBalloon}) no-repeat left center;
  background-size: contain;
  position: absolute;
  right: 28%;
  bottom: 16%;
`;

const LinkAccountDoneWrapper = styled(Flex)`
  ${({ hasAccount }) =>
    `background: url(${
      hasAccount ? SlackConnectedSuccessfullyBackground : PurpleDude
    }) no-repeat center bottom;
    background-size: ${hasAccount ? '32rem' : '8rem'}`};
`;

const InvitationSent = styled(Flex)`
  align-items: center;
  justify-content: center;
  width: 20rem;
  height: 3rem;
  background-color: ${getColor('feta')};
  border-radius: 6px;
`;

const LinkAccountDoneModal = ({
  isSensorAuth = true,
  hasAccount = false,
  isContributor = false,
  isMultipleOrgsContrib = false,
  toggleModal,
  accountId
}) => {
  const { isRequested, setIsRequested } = usePostAskForInvitation(accountId);
  const history = useHistory();
  return (
    <LinkAccountDoneWrapper
      direction='column'
      height='100%'
      hasAccount={hasAccount}
    >
      <Flex
        direction='column'
        items='center'
        grow='1'
        pr='medium'
        pl='medium'
        height='100%'
      >
        {!hasAccount && <Logo src={svgLogo} />}
        <Text
          size='x-x-x-large'
          weight='300'
          pt={!isContributor ? '12rem' : hasAccount ? '16rem' : '8rem'}
          pb={SPACES.big}
          color='black'
        >
          {isContributor
            ? `Success!`
            : !isMultipleOrgsContrib
            ? `Sorry, we did not recognize you`
            : 'We are sorry'}
        </Text>

        {isContributor && !isMultipleOrgsContrib ? (
          <>
            <Text
              size='x-large'
              lineHeight={LINE_HEIGHT['x-large']}
              pb={SPACES.big}
              color='shuttleGray'
            >
              Your LinearB account is connected to{' '}
              {getCollaborationProviderName()},
              <br />
              you can start using your {getCollaborationProviderName()}{' '}
              commands!
            </Text>
            {!hasAccount && (
              <Text
                size='x-large'
                lineHeight={LINE_HEIGHT['x-large']}
                pb={SPACES.medium}
                color='shuttleGray'
              >
                Want access to your LinearB Dashboard?
              </Text>
            )}
          </>
        ) : !isSensorAuth && !isMultipleOrgsContrib ? (
          <Text
            size='x-large'
            lineHeight={LINE_HEIGHT['x-large']}
            pb={SPACES.medium}
            color='shuttleGray'
          >
            It looks like we could not connect you at the moment.
            <br />
            Please contact our support to resolve this.
          </Text>
        ) : !isMultipleOrgsContrib ? (
          <Text
            size='x-large'
            lineHeight={LINE_HEIGHT['x-large']}
            pb={SPACES.medium}
            color='shuttleGray'
          >
            Looks like you don’t have a LinearB account yet...
            <br />
            No problem. You’ll be in before you know it.
          </Text>
        ) : (
          <Text
            size='x-large'
            lineHeight={LINE_HEIGHT['x-large']}
            pb={SPACES.medium}
            color='shuttleGray'
          >
            It looks like your Git user appears in more than one LinearB
            account.
            <br />
            Please contact our support to resolve this.
          </Text>
        )}
        {!isRequested ? (
          <LBButton
            onClick={() => {
              getButtonProps({
                hasAccount,
                isContributor,
                isMultipleOrgsContrib,
                history,
                ZendeskService,
                toggleModal
              }).action(setIsRequested);
            }}
          >
            {
              getButtonProps({
                hasAccount,
                isContributor,
                isMultipleOrgsContrib,
                history,
                ZendeskService
              }).text
            }
          </LBButton>
        ) : (
          <InvitationSent pl='small' pr='small' pt='small' pb='x-small'>
            <Icon name='Checkmark' size='small' color='funGreen' />
            <Text color='funGreen' size='large' pl='0.5rem'>
              Request for invitation sent
            </Text>
          </InvitationSent>
        )}
      </Flex>
      {!hasAccount && (
        <SpeechBalloonBox>
          <LBButton
            variant='ghost'
            onClick={() => {
              window.open('https://linearb.io/');
            }}
          >
            Visit LinearB.io to learn more about us
          </LBButton>
        </SpeechBalloonBox>
      )}
      {!hasAccount && isContributor && (
        <Flex padding='normal'>
          <LBButton
            variant='ghost'
            onClick={() => history.push(AppRouter.LOGIN.path)}
          >
            &lt; back to login
          </LBButton>
        </Flex>
      )}
    </LinkAccountDoneWrapper>
  );
};

export default LinkAccountDoneModal;
